import React, { useMemo } from 'react';
import { useSubscriberDomainParams } from 'global/hooks/useSubscriberDomainParams';
import IMQSubscriberProfilePageStore, {
  IMQSubscriberProfilePageStoreContext,
} from 'store/pages/subscriber/imq/imq-subscriber-profile/pageStore';
import PageContent from 'components/subscriber/imq/imq-subscriber-profile';

const IMQSubscriberProfilePage: React.FC = () => {
  const { groupId, subscriberId, entityId } = useSubscriberDomainParams();

  const pageStore = useMemo(
    () => new IMQSubscriberProfilePageStore({ groupId, subscriberId, entityId }),
    [groupId, subscriberId, entityId],
  );

  return (
    <IMQSubscriberProfilePageStoreContext.Provider value={pageStore}>
      <PageContent />
    </IMQSubscriberProfilePageStoreContext.Provider>
  );
};

export default IMQSubscriberProfilePage;
